// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth"; 
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDFIH3AF2EY2dZtrcOSppnAFvxvk4w7OLw", 
  authDomain: "recipe-book-app-1.firebaseapp.com",
  projectId: "recipe-book-app-1",
  storageBucket: "recipe-book-app-1.firebasestorage.app",
  messagingSenderId: "231676114805",
  appId: "1:231676114805:web:537596ec79533240dec53c",
  measurementId: "G-BXNMKGT26E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Services AND Export them in one step
export const analytics = getAnalytics(app);

// Initialize Firestore with robust multi-tab IndexedDB offline caching
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const storage = getStorage(app);